export default __webpack_public_path__ + "static/media/Apple iMac 27-inch (Late 2009 - Late 2012).421bb1b9.png";